import React from 'react';
import { brandGradients } from '../theme/palette';

const Experience = () => {
  const achievements = [
    {
      icon: 'fas fa-award',
      title: 'Disciplinary Work Approach',
      description: 'Our work follows a structured, disciplinary manner ensuring consistent quality and professionalism.'
    },
    {
      icon: 'fas fa-user-shield',
      title: 'Outsourced Verification Agency (OVA)',
      description: 'Excellence in OVA services producing confidential reports for banks without disclosing customer data.'
    },
    {
      icon: 'fas fa-clock',
      title: 'Timely Report Delivery',
      description: 'Consistent track record of delivering comprehensive reports within committed timeframes.'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Trusted Banking Partner',
      description: 'Empaneled with SBI, Karnataka Bank and serving financial institutions across South India.'
    }
  ];

  const empanelments = [
    {
      name: 'State Bank of India (SBI)',
      type: 'Primary Banking Partner',
      icon: 'fas fa-university',
      color: 'from-blue-600 to-blue-700'
    },
    {
      name: 'Karnataka Bank',
      type: 'Regional Banking Partner', 
      icon: 'fas fa-building',
      color: 'from-green-600 to-green-700'
    },
    {
      name: 'Financial Institutions',
      type: 'Multiple Partnerships',
      icon: 'fas fa-chart-line',
      color: 'from-purple-600 to-purple-700'
    },
    {
      name: 'Software Companies',
      type: 'Corporate Clients',
      icon: 'fas fa-laptop-code',
      color: 'from-indigo-600 to-indigo-700'
    }
  ];

  return (
    <section id="experience" className="py-20 lg:py-16 bg-gradient-to-br from-gray-50 to-blue-50">
  <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16 animate-on-scroll">
          <span className="text-[#00a4f4] text-xl font-bold"style={{ color: '#ff70a6' }}>
            Our Experience & Empanelments
          </span>
          <h2 className="text-4xl lg:text-6xl font-black text-gray-800 mt-4 mb-8 leading-tight">
            Trusted Partner Since
            <span className="block text-blue-600">2019</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Established in 2019, RLDS Pvt Ltd has built strong partnerships with leading banks and 
            financial institutions across Andhra Pradesh, Telangana, Karnataka & Tamil Nadu.
          </p>
        </div>

        {/* Timeline */}
        <div className="mb-20 animate-on-scroll">
          <div className="bg-white rounded-3xl p-8 lg:p-12 shadow-1xl border border-blue-100">
            <div className="text-center mb-12">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-6 shadow-xl" style={{ background: brandGradients.panel }}>
                <i className="fas fa-calendar-alt text-white text-3xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 mb-4">Our Journey</h3>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6 bg-blue-50 rounded-2xl">
                <div className="text-4xl font-bold text-blue-600 mb-2">2019</div>
                <div className="font-semibold text-gray-800 mb-2">Established</div>
                <div className="text-gray-600 text-sm">Founded by L. Raghuveer Reddy in Kurnool, Andhra Pradesh</div>
              </div>

              <div className="text-center p-6 bg-green-50 rounded-2xl">
                <div className="text-4xl font-bold text-green-600 mb-2">2019-20</div>
                <div className="font-semibold text-gray-800 mb-2">Banks and Corporates Empanelments</div>
                <div className="text-gray-600 text-sm">Empaneled with SBI, Karnataka and other nationalized Banks as OVA partner</div>
              </div>

              <div className="text-center p-6 bg-purple-50 rounded-2xl">
                <div className="text-4xl font-bold text-purple-600 mb-2">2020+</div>
                <div className="font-semibold text-gray-800 mb-2">Expansion</div>
                <div className="text-gray-600 text-sm">Extended services across 4 states with multiple partnerships</div>
              </div>
            </div>
          </div>
        </div>

        {/* Achievements */}
        <div className="mb-20 animate-on-scroll">
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-12">Our Key Achievements</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => {
              const tileGradients = [
                'linear-gradient(135deg, #ffb703 100%)',
                'linear-gradient(135deg, #3a86ff 100%)',
                'linear-gradient(135deg, #ff006e 100%)',
                'linear-gradient(135deg, #06d6a0 100%)',
              ];
              const tileStyle = { background: tileGradients[index % tileGradients.length] };
              return (
              <div 
                key={index}
                className="group p-6 bg-white rounded-2xl shadow-1xl hover:shadow-1xl transition-all duration-500 border border-gray-100 hover:border-blue-200"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="text-center">
                  <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg" style={tileStyle}>
                    <i className={`${achievement.icon} text-white text-2xl`}></i>
                  </div>
                  <h4 className="text-lg font-bold text-gray-800 mb-4 group-hover:text-blue-600 transition-colors duration-300">
                    {achievement.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {achievement.description}
                  </p>
                </div>
              </div>
            );})}
          </div>
        </div>

        {/* Empanelments */}
        <div className="animate-on-scroll">
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-12">Our Trusted Partners</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {empanelments.map((partner, index) => (
              <div 
                key={index}
                className="group p-8 bg-white rounded-3xl shadow-1xl hover:shadow-1xl transition-all duration-500 border border-gray-100 hover:border-blue-200 text-center"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={`w-20 h-20 bg-gradient-to-r ${partner.color} rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-xl`}>
                  <i className={`${partner.icon} text-white text-2xl`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors duration-300">
                  {partner.name}
                </h4>
                <p className="text-gray-600 text-sm font-medium">
                  {partner.type}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Stats */}
        <div className="mt-20 animate-on-scroll">
          <div className="rounded-3xl p-12 text-white text-center" style={{ background: brandGradients.panel }}>
            <h3 className="text-3xl lg:text-4xl font-bold mb-8">
              Serving South India with Excellence
            </h3>
            <div className="grid md:grid-cols-4 gap-8">
              <div>
                <div className="text-4xl font-bold mb-2">2019</div>
                <div className="text-sm opacity-80">Year Established</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">4</div>
                <div className="text-sm opacity-80">States Coverage</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">25+</div>
                <div className="text-sm opacity-80">Cities Served</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">100%</div>
                <div className="text-sm opacity-80">Confidential Service</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;